import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { CarsState } from "../../types";

import { getCarEBoxDashboardData } from "../operations/getCarEBoxDashboardData";

import { STATUS_LOADING } from "common/constants";

export const setEBoxDashboardData = (builder: ActionReducerMapBuilder<CarsState>) => builder
  .addCase(getCarEBoxDashboardData.pending, (state) => {
    state.eBoxDashboardData.loadingStatus = STATUS_LOADING.load;
  })
  .addCase(getCarEBoxDashboardData.fulfilled, (state, { payload }) => {
    state.eBoxDashboardData.loadingStatus = STATUS_LOADING.done;
    state.eBoxDashboardData.data = payload;
  })
  .addCase(getCarEBoxDashboardData.rejected, (state) => {
    state.eBoxDashboardData.loadingStatus = STATUS_LOADING.error;
  });